import * as actions from './slice'

const permissionsUpload = {
  eventName: 'userPermissionsUpload',
  onStart: [{
    action: actions.reset,
    redux: true
  }, {
    action: () => actions.setLoading(true),
    redux: true
  }],
  onSuccess: [{
    action: actions.setResults,
    redux: true
  }]
}

export {
  permissionsUpload
}
